export default __webpack_public_path__ + "static/media/3.8ac29f11.jpg";